import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
  },
  {
    path: '/beta',
    component: () => import('@/Home'),
    children: [
      {
        path: '',
        name: 'app',
        component: () => import('@/views/main/index.vue'),
        meta: { title: '首页' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 })
})


export default router
